import { checkPermissionLevel, setPermissions } from './utils'

// this is handling google maps icon in SliderOptions/PropertyView/ProjectView & checkbox in OfferSettingsModal, rest is handled via allowedTabs
export const setGoogleMaps = ({ agentPermissions, selectedProperty, isAgentOwnership, isAgentOffice, currentAgentId, currentOffice, module }) => {
    const permission = module === 'properties' ? 'view.property.map' : 'view.project.map'

    // related to the map tab in SliderOptions, PropertyView & ProjectView
    const showMapsSlider = setPermissions(agentPermissions, permission, isAgentOwnership, isAgentOffice)

    // related to the checkbox in OfferSettingsModal
    const level = checkPermissionLevel(agentPermissions, permission)
    const permissions = {
        all: true,
        office: selectedProperty?.primaryAgent?.agencyOffice?.id === currentOffice.id,
        own: selectedProperty?.primaryAgent?.id === currentAgentId,
    }
    const showMapsOffer = level in permissions ? permissions[level] : false

    return { showMapsSlider, showMapsOffer }
}
